const t = "_arrow_6t28k_1", o = "_top_6t28k_19", _ = "_bottom_6t28k_30", n = "_left_6t28k_41", c = "_right_6t28k_52", r = "_content_6t28k_64", s = {
  arrow: t,
  top: o,
  bottom: _,
  left: n,
  right: c,
  content: r
};
export {
  t as arrow,
  _ as bottom,
  r as content,
  s as default,
  n as left,
  c as right,
  o as top
};
//# sourceMappingURL=Popover.module.css.js.map
